// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import '@/assets/css/reset.css'
import './assets/fonts/index.css'
import ElementUI from 'element-ui'
import './assets/css/theme/index.css' // ff9300
import './assets/iconfont/iconfont.css'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.image_prefix = "http://kpl.pentaq.com/uploads/";
Vue.prototype.image_prefix_bk = "http://bk.pentaq.com/uploads/";
Vue.prototype.format_data = function (value, format, additional) {

  if (value === undefined || value === null) {
    if (additional && additional.null_value) {
      return additional.null_value
    }
    return value
  }

  if (format) {
    let regx = /^-?[0-9]\d*$/
    if (format == 'percent') {
      if (!regx.test(parseFloat(value) * 100)) {
        return (parseFloat(value) * 100).toFixed(1) + '%'
      } else {
        return (parseFloat(value) * 100) + '%'
      }
    } else if (format == 'float') {
      if (!regx.test(parseFloat(value))) {
        return parseFloat(value).toFixed(2)
      } else {
        return parseFloat(value)
      }
    } else if (format == 'time-minute') {
      if (additional && additional.is_millisecond) {
        value = value / 1000
      }

      let min = Math.floor(value / 60)
      let sec = Math.round(value % 60)
      min = min > 9 ? min : '0' + min
      sec = sec > 9 ? sec : '0' + sec
      if (min) {
        return min + "m " + sec + 's'
      } else {
        return sec + 's'
      }
    } else if (format == 'time-hour') {
      if (additional && additional.is_millisecond) {
        value = value / 1000
      }

      let hour = Math.floor(value / 3600)
      let min_time = Math.round(value % 3600)
      let min = Math.floor(min_time / 60)
      let sec = Math.round(min_time % 60)

      if (hour) {
        return hour + 'h ' + min + "m " + sec + 's'
      } else {
        return min + "m " + sec + 's'
      }
    } else if (format == 'int') {
      return Math.round(value)
    } else if (format == 'rank') {
      if (!regx.test(parseFloat(value)) || value < 1) {
        return "-"
      } else {
        if (value == 1) {
          return "1st"
        }
        if (value == 2) {
          return "2nd"
        }
        if (value == 3) {
          return "3rd"
        }
        return value + "th"
      }
    } else if (format == 'mm:ss') {
      if (additional && additional.is_millisecond) {
        value = value / 1000
      }

      let hour = Math.floor(value / 3600)
      let min_time = Math.round(value % 3600)
      let min = Math.floor(min_time / 60)
      let sec = Math.round(min_time % 60)
      if(min < 10){
        min = `0${min}`
      }
      if(sec < 10){
        sec = `0${sec}`
      }

      if (hour) {
        return hour + ':' + min + ":" + sec
      } else {
        return min + ':' + sec
      }
    }
  }
  return value
};

Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js